import {fieldValidator, formDataFBuilder} from "../Core/common";
import Agent from "../Core/agent";
import {notice} from "../UI/notice";
import {modal} from "../UI/modal";
import FilterAPi from "../Api/filter-api";
import {changeInputFile} from "../input-file";

const elements = new WeakSet;

const state = {
    isPending: false
};

let fileEvents = null;

const modalConfig = {
    'size': 'modal-dialog-centered',
    'title': '',
    'message': '',
    'footer': '',
    'header': function () {
        return `<div class="modal-header">
                ${modalConfig.closeBtm}
            </div>`;
    },
    'closeBtm': `<button class="btn-close btn-inline href-main position-absolute d-flex bg-transparent" data-bs-dismiss="modal">
                    <i class="icon close fs-24"></i>
                </button>`,
};


const sendInfo = async (output, button) => {
    button.classList.add('preloader');
    let response = await Agent.post('/api/v1/form/send-form', output);
    try {
        return await response.json();
    } catch (e) {
        notice(e.message);
    } finally {
        button.classList.remove('preloader');
    }
};

const initForm = async form => {
    let required_field_flag;

    form.querySelectorAll(`input, textarea`).forEach(el => {
        if (el.hasAttribute('name')) {
            el.addEventListener('input', event => {
                    let input = fieldValidator.bind(null, event.currentTarget);
                    clearTimeout(required_field_flag);
                    required_field_flag = setTimeout(input, 1000);
                }
            );

            el.addEventListener('focus', () => {
                el.classList.remove('is-invalid');
                el.classList.remove('is-valid');
            });

            el.addEventListener('blur', event => {
                let input = fieldValidator.bind(null, event.currentTarget);

                clearTimeout(required_field_flag);
                required_field_flag = setTimeout(input, 10);
            });

            if (el.getAttribute('type') === 'file') {
                el.addEventListener('change', () => changeInputFile(el));
            }
        }
    });

    let buttons = form.querySelectorAll('button[type="submit"]');
    if (!buttons.length) {
        buttons = form.querySelectorAll('button');
    }
    if (buttons) {
        let last = buttons[buttons.length - 1];
        let inputs = form.querySelectorAll(`input, textarea`);

        last.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            let isError = false;

            inputs.forEach(el => {
                if (el.hasAttribute('name')) {
                    if (!fieldValidator(el)) {
                        isError = true;
                    }
                }
            });

            if (!isError) {
                let form_name = form.getAttribute("name");
                let data = formDataFBuilder(form);
                data.append('key', 'msg_form');
                data.append('page', window.location.pathname.substr(1));
                data.append('product', last.dataset.product_id || 0);
                data.append('time_zone', document.querySelector('body').dataset.time_zone || 0);
                data.append('form_name', form_name);
                data.append('ya_event_id', form.dataset.ya_id);
                data.append('ya_event_key', form.dataset.ya_key);

                let result = sendInfo(data, last);
                result.then(e => {
                    if (e.success) {
                        try{
                            ym(window.reachGoalId,'reachGoal','lead')
                        }catch (e){}

                        let filter = ['hidden', 'radio', 'checkbox', 'number', 'select', 'count', 'product', 'product_dependent'];

                        let js_form_file_list = form.querySelector('.js_form_file_list');
                        if (js_form_file_list) {
                            js_form_file_list.innerHTML = '';
                        }

                        inputs.forEach(el => {
                            if (!filter.includes(el.type)) {
                                el.value = '';
                            }

                            if (el.type === 'checkbox') {
                                el.checked = false;
                            }

                            el.classList.remove('is-invalid');
                            el.classList.remove('is-valid');
                        });
                        modalConfig.message = `<div class="modalc-success modal-block d-flex flex-column align-items-center"> 
                    <span class="fs-24 fw-md">Спасибо за заявку!</span>
                    <p>Мы скоро свяжемся с вами</p>
                    <hr class="my-0 w-100">
                    <div class="d-flex flex-column gap-16">
                        <span class="fs-16 fw-md lh-1_3">Посетите наши страницы в соцсетях</span>
                        <div class="d-flex gap-16 justify-content-center">
                            <a class="footer-feedback__social-icon bg-light d-flex align-items-center justify-content-center" href="https://vk.com/flowerbox13" target="_blank">
                                <img src="/images/vk_black.svg" alt="Логотип Вконтакте">
                            </a>
                            <a class="footer-feedback__social-icon bg-light d-flex align-items-center justify-content-center" href="https://www.instagram.com/flowerbox13" target="_blank">
                                <img src="/images/insta_black.svg" alt="Логотип Instagram">
                            </a>
                        
                        </div>
                    </div>
                    <hr class="my-0 w-100">
                    <div class="d-flex flex-column gap-16"><span class="fs-16 fw-md lh-1_3">Пишите нам в мессенджеры</span>
                        <div class="d-flex gap-32">
                            <a class="href-main footer-feedback__social-item d-flex align-items-center" href="https://t.me/+79271988667?text=Здравствуйте,%20хочу%20заказать%20у%20вас%20цветы" target="_blank">
                                <div class="footer-feedback__social-icon bg-light d-flex align-items-center justify-content-center">
                                    <img src="/images/tg.svg" alt="Логотип Telegram">
                                </div>
                                <span class="fs-16">Написать <br> в Telegram </span>
                            </a>
                            <a class="href-main footer-feedback__social-item d-flex align-items-center" href="https://wa.me/79297473887?text=Здравствуйте,%20хочу%20заказать%20у%20вас%20цветы" target="_blank">
                                <div class="footer-feedback__social-icon bg-light d-flex align-items-center justify-content-center">
                                <img src="/images/wa.svg" alt="Логотип WhatsApp">
                                </div>
                                    <span class="fs-16">Написать <br> в WhatsApp</span>
                            </a>
                        </div>
                    </div>
                </div>`;
                        modalConfig.size = 'modal-dialog modal-dialog-centered';

                        modal(modalConfig, function (el, modal) {
                            setTimeout(modal.hide.bind(modal), 5000);
                        });

                    } else {
                        notice(e.message);
                    }
                });
            }
        });
    }
};

const openForm = async btn => {
    let button = btn.currentTarget;
    button.disabled = true;
    if (!state.isPending) {
        state.isPending = true;

        let cnt = 1;
        let block = button.closest('.js_item');
        if (block) {
            let countElement = block.querySelector('[name="count"]');
            if (countElement) {
                cnt = countElement.value;
            }
        }

        let output = new FormData();
        output.append('key', 'open_form');
        output.append('ya_event_id', button.dataset.yaID);
        output.append('ya_event_key', button.dataset.yaKey);
        output.append('form_name', button.name || button.dataset.name);
        output.append('product', button.dataset.product_id || 0);
        output.append('employee', button.dataset.employee_id || 0);
        output.append('payment', button.dataset.payment_id || 0);
        output.append('user', button.dataset.user);
        output.append('count', cnt);
        output.append('data_json', JSON.stringify({}));

        button.classList.add('preloader');

        let response = await Agent.post('/api/v1/form/open-form', output);
        try {
            const result = await response.json();
            if (result.success) {
                modalConfig.message = result.data || '';
                modalConfig.size = button.dataset.size || 'modal-dialog-centered';
                modalConfig.title = result.title || '';
                modal(modalConfig, function (el) {
                    let filterBtn = el.querySelector('.js_filter_select_btn');
                    if (filterBtn) {
                        let jsFilterResult = el.querySelector('.js_filter_result');
                        jsFilterResult.innerHTML = '';

                        filterBtn.addEventListener('click', () => {
                            let dataValuesString = [];
                            let dataValuesInt = [];
                            el.querySelectorAll('.js_filter_select').forEach(item => {
                                if (item.dataset.type === 'int') {
                                    dataValuesInt.push({
                                        id: item.dataset.parameter_id,
                                        name: item.dataset.alias,
                                        min: item.value,
                                        max: item.value
                                    });
                                }
                                if (item.dataset.type === 'string') {
                                    dataValuesString.push({
                                        id: item.dataset.parameter_id,
                                        name: item.dataset.alias,
                                        values: [item.value]
                                    });
                                }
                            });

                            let parameters = {
                                type: 'search_for_modal',
                                category: el.querySelector('.js_filter_category').value,
                                page: 1,
                                limit: 3,
                                float: dataValuesInt,
                                string: dataValuesString,
                            };

                            filterBtn.classList.add('preloader');

                            FilterAPi.search(parameters).then(response => response.json()).then(response => {
                                jsFilterResult.innerHTML = response.data;
                                fileEvents.dispatch('filter.search');
                            }).finally(() => {
                                filterBtn.classList.remove('preloader');
                            });
                        });
                    }
                    let form = el.querySelector('form');
                    if (form) {
                        initForm(form);
                    }
                });
            } else {
                notice(result.message);
            }
        } catch (e) {
            notice(e.message);
        } finally {
            button.classList.remove('preloader');
            button.disabled = false;
            state.isPending = false;
        }
    }
};

export default class Forms {
    constructor(events) {
        fileEvents = events;
        this.events = events;
        this.initInlineForm(document);
        this.initModalForm(document);
    }

    initInlineForm(element) {
        element.querySelectorAll('.js_form').forEach(item => {
            if(!elements.has(item)){
                elements.add(item)
                initForm(item);
            }
        });
    }

    initModalForm(element) {
        element.querySelectorAll('.js_open_form').forEach(item => {
            if(!elements.has(item)) {
                elements.add(item)
                item.addEventListener('click', openForm);
            }
        });
    }
}